import { Row } from '@advanza/grid'
import PhoneClicksFilterContainer from 'containers/PhoneClicksFilterContainer'
import PropTypes from 'prop-types'
import React from 'react'
import Pagination from '../Pagination'

class PhoneClicksFilter extends React.Component {
    constructor(props) {
        super(props)
        this.onPageChange = this.onPageChange.bind(this)
        this._changeFilter = this._changeFilter.bind(this)
    }

    _changeFilter(options) {
        const { changeFilter, filterId } = this.props
        changeFilter(filterId, options)
    }

    componentDidMount() {
        const { defaultOptions = {}, filter } = this.props
        if (!filter) {
            this._changeFilter(defaultOptions)
        }
    }

    componentDidUpdate(prevProps) {
        const prevFilter = prevProps.filter || {}
        const { filter = {}, defaultOptions = {} } = this.props
        const didInvalidate = !prevFilter.didInvalidate && filter.didInvalidate
        if (didInvalidate) {
            // Because the filter is invalidated changing it will refetch the items.
            this._changeFilter(defaultOptions)
        }
    }

    onPageChange(page, invalidate = false) {
        this._changeFilter({ page, didInvalidate: invalidate })
    }

    render() {
        const { filter, count, compact } = this.props
        if (!filter || compact) {
            return null
        }

        const pageNr = filter.page || 0
        return (
            <Row middle="xs" end="xs">
                {count > filter.pageSize && (
                    <div>
                        <Pagination
                            current={pageNr}
                            pageSize={filter.pageSize}
                            count={count}
                            onPageChange={this.onPageChange}
                        />
                    </div>
                )}
            </Row>
        )
    }
}

PhoneClicksFilter.propTypes = {
    defaultOptions: PropTypes.object,
    filterId: PropTypes.string.isRequired,
    filter: PropTypes.object,
    changeFilter: PropTypes.func,
    compact: PropTypes.bool,
}

export default PhoneClicksFilterContainer(PhoneClicksFilter)
